import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";

import { RelodeTheme, Text } from "../";
import { IFacet } from "./types";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            alignItems: "center",
        },
        spaceBefore: {
            marginLeft: "5px",
        },
        facetOption: {
            cursor: "pointer",
        },
    });

interface Props extends WithStyles<typeof styles> {
    facet: IFacet;
    onFilter: (item: { value: string; label: string }) => void;
}

export const FacetListItem = withStyles(styles)((props: Props) => {
    const { classes, facet, onFilter } = props;

    return (
        <Text className={classes.root} variant="body1">
            <span
                className={classes.facetOption}
                data-cy={`${facet.id}-facet-text`}
                onClick={() =>
                    onFilter({
                        value: facet.id.toString(),
                        label: facet.name,
                    })
                }
            >
                {facet.name}
                <span
                    data-cy={`${facet.id}-facet-count`}
                    className={classes.spaceBefore}
                >
                    ({facet.count})
                </span>
            </span>
        </Text>
    );
});
